import * as React from "react";
function SvgLab(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.5 3.208h-1v2.5h2.25v5.167L4.6 16.408c-1.483 1.978-.072 4.8 2.4 4.8h10c2.472 0 3.883-2.822 2.4-4.8l-4.15-5.533V5.708h2.25v-2.5h-10zm3.25 3.75v-1.75h2.5v6.334l.2.266 2.55 3.4H8l2.55-3.4.2-.266V6.958zM6.5 17.208l-.3.4a1 1 0 00.8 1.6h10a1 1 0 00.8-1.6l-.3-.4h-11z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgLab);
export default ForwardRef;
